import classnames from 'classnames';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useClickAway } from 'react-use';

import 'react-input-checkbox/lib/react-input-checkbox.min.css';

import closeImg from 'images/icons/close.png';

import styles from './index.css';

export interface ShareModalProp {
    className?: string;
    url: string;
    onCheckPos?: (checked: boolean) => void;
    onClose?: () => void;
}

const ShareModal: React.FC<ShareModalProp> = ({
    className,
    url,
    onCheckPos = () => {},
    onClose = () => {},
}) => {
    const ref = useRef(null);
    useClickAway(ref, onClose);

    const inputEl = useRef<HTMLInputElement>(null);

    const [checked, setChecked] = useState(false);

    const copiedTimeout = useRef<number | null>(null);
    const [copied, setCopied] = useState(false);

    const copy = useCallback(() => {
        if (inputEl.current) {
            inputEl.current.select();
            navigator.clipboard.writeText(inputEl.current.value);
            setCopied(true);

            if (copiedTimeout.current) {
                window.clearTimeout(copiedTimeout.current);
                copiedTimeout.current = null;
            }

            copiedTimeout.current = window.setTimeout(() => {
                setCopied(false);
                document.getSelection()?.removeAllRanges();

                copiedTimeout.current = null;
            }, 1500);
        }
    }, []);

    useEffect(() => {
        return () => {
            if (copiedTimeout.current) {
                window.clearTimeout(copiedTimeout.current);
                copiedTimeout.current = null;
            }
        };
    }, []);

    return (
        <div className={classnames(styles.shareModal, className)}>
            <div ref={ref} className={styles.container}>
                <div
                    className={styles.close}
                    role="button"
                    tabIndex={0}
                    onKeyPress={() => {}}
                    onClick={onClose}
                >
                    <img src={closeImg} alt="close" />
                </div>
                <div className={styles.title}>share</div>
                <div className={styles.linkGroup}>
                    <input ref={inputEl} className={styles.linkInput} value={url} readOnly />
                    <div
                        className={styles.button}
                        role="button"
                        tabIndex={0}
                        onKeyPress={() => {}}
                        onClick={copy}
                    >
                        {copied ? '已複製！' : '複製'}
                    </div>
                </div>
                <div
                    className={styles.checkGroup}
                    role="button"
                    tabIndex={0}
                    onClick={() => {
                        setChecked(!checked);
                        onCheckPos(!checked);
                    }}
                    onKeyPress={() => {}}
                >
                    <div className={styles.checkbox}>
                        <input type="checkbox" checked={checked} readOnly />
                        <span className={styles.checkmark} />
                    </div>
                    <span className={styles.label}>連結至此位置</span>
                </div>
            </div>
        </div>
    );
};

export default ShareModal;
